export const ACTION_SCHEDULE_WORK_ORDER = 'SCHEDULE_WORK_ORDER';
